import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import A from 'wanderu-component-react-router-link';
import { BusLoader } from 'wanderu-components';
import { localize } from 'wanderu-i18n';

import chiku from 'wanderu-assets/images/chiku.svg';

import localesConfig from '../../../config/explorer.locales';
import Search from '../../components/Search/Search';

import styles from './ExplorerHeader.scss';

const SELECTED_RESPONSE_KEYS = [
    'awesome-time-of-year-chiku-response',
    'pack-your-bags-chiku-response',
    'city-calling-your-name-chiku-response',
];

class ExplorerHeader extends React.Component {
    static propTypes = {
        date: PropTypes.string,
        hideResults: PropTypes.bool,
        input: PropTypes.string,
        locale: PropTypes.string.isRequired,
        onDateChange: PropTypes.func,
        onInputBlur: PropTypes.func,
        onInputChange: PropTypes.func,
        onInputFocus: PropTypes.func,
        onLocationChange: PropTypes.func,
        onNearbyCityClick: PropTypes.func,
        onPriceChange: PropTypes.func,
        onSearch: PropTypes.func,
        price: PropTypes.number,
        status: PropTypes.object,
        t: PropTypes.func,
    };

    static defaultProps = {
        hideResults: false,
        onDateChange() {},
        onInputBlur() {},
        onInputChange() {},
        onLocationChange() {},
        onNearbyCityClick() {},
        onPriceChange() {},
        onSearch() {},
        status: {},
    };

    defaultText() {
        const { t } = this.props;

        return {
            areNearbyCities: false,
            mainText: t('help-you-explore-chiku'),
            mainTextDesktop: t('feeling-adventurous-chiku'),
            showMobileTitle: true,
            titleText: t('chiku-hi-hi-greeting'),
        };
    }

    invalidSearchText() {
        const { t } = this.props;

        return {
            areNearbyCities: false,
            mainText: t('select-location-chiku-warning'),
            mainTextDesktop: '',
            showMobileTitle: true,
            titleText: t('woah'),
        };
    }

    searchingText() {
        const { t } = this.props;

        return {
            areNearbyCities: false,
            mainText: t('chiku-searching-text'),
            mainTextDesktop: '',
            showMobileTitle: true,
            titleText: '',
        };
    }

    noDirectServiceText(status) {
        const { t } = this.props;
        const { nearbyCities = [] } = status.noDirectService;
        let mainTextDesktop = '';
        let mainText = '';

        if (nearbyCities.length > 1) {
            mainTextDesktop = t('no-direct-service');
            mainText = t('check-out-close-by-cities');
        } else if (nearbyCities.length === 1) {
            mainTextDesktop = t('no-direct-service');
            mainText = t('check-out-close-by-city');
        } else {
            mainTextDesktop = '';
            mainText = t('no-direct-service-try-another-city');
        }

        return {
            areNearbyCities: nearbyCities.length > 0,
            mainText,
            mainTextDesktop,
            showMobileTitle: false,
            titleText: t('uh-oh'),
        };
    }

    selectedCityText(status) {
        const { t } = this.props;
        const { selectedCity } = status;
        const cityName = selectedCity.location.city;
        const randomNumber = Math.floor(Math.random() * (3));
        const responseKey = SELECTED_RESPONSE_KEYS[randomNumber];

        return {
            areNearbyCities: false,
            mainText: t(responseKey, { cityName }),
            mainTextDesktop: '',
            showMobileTitle: true,
            titleText: '',
        };
    }

    hasResultsText(status) {
        const { t } = this.props;

        let mainTextDesktop = '';
        let mainText = '';

        if (status.hasResults.size > 5) {
            mainText = t('so-many-adventures-chiku');
        } else {
            mainTextDesktop = t('here-is-what-I-could-find');
            mainText = t('adventures-are-so-exciting-arent-they');
        }

        return {
            areNearbyCities: false,
            mainText,
            mainTextDesktop,
            showMobileTitle: true,
            titleText: '',
        };
    }

    noResultsText() {
        const { t } = this.props;

        return {
            areNearbyCities: false,
            mainText: t('change-your-budget-or-date'),
            mainTextDesktop: t('could-not-find-anything'),
            showMobileTitle: true,
            titleText: t('uh-oh'),
        };
    }

    buildStatusText(status) {
        if (status.invalidSearch) {
            return this.invalidSearchText();
        }

        if (status.searching) {
            return this.searchingText();
        }

        if (status.noDirectService) {
            return this.noDirectServiceText(status);
        }

        if (status.selectedCity) {
            return this.selectedCityText(status);
        }

        if (status.hasResults) {
            return this.hasResultsText(status);
        }

        if (status.noResults) {
            return this.noResultsText();
        }

        return this.defaultText();
    }

    renderNearbyCitiesLinks() {
        const {
            status,
            onNearbyCityClick,
        } = this.props;
        const { nearbyCities } = status.noDirectService;

        return nearbyCities.map((nearbyCity, i) => {
            const lastCity = nearbyCities.length === i + 1;
            return [
                <span key={`${nearbyCity.wcityid}-span`}> </span>,
                <A
                    className={styles.nearbyCityLink}
                    href={`/explore/${nearbyCity.url}`}
                    key={nearbyCity.wcityid}
                    onClick={(e) => onNearbyCityClick(e, nearbyCity.wcityid)}
                >
                    {nearbyCity.city}
                </A>,
                <span key={`${nearbyCity.wcityid}-punctuation`}>{lastCity
                    ? '.'
                    : ','}</span>,
            ];
        });
    }

    render() {
        const {
            date,
            hideResults,
            input,
            locale,
            onDateChange,
            onInputBlur,
            onInputChange,
            onInputFocus,
            onLocationChange,
            onPriceChange,
            onSearch,
            price,
            status,
        } = this.props;
        const {
            areNearbyCities,
            mainText,
            mainTextDesktop,
            showMobileTitle,
            titleText,
        } = this.buildStatusText(this.props.status);

        return (
            <div className={styles.searchContainer}>
                <div>
                    <div className={styles.chikuSpeechContainer}>
                        <div className={styles.chikuContainer}>
                            <img alt="chiku" className={styles.chiku} src={chiku} />
                        </div>
                        <div className={`${styles.speechBubble}`}>
                            <div className={`${styles.speech}`}>
                                <div
                                    className={`${showMobileTitle
                                        ? ''
                                        : styles.hiddenMobile}`}
                                >
                                    {titleText}
                                </div>
                                <span className={styles.desktopSpeech}>
                                    {mainTextDesktop}&nbsp;
                                </span>
                                {mainText}
                                {areNearbyCities && this.renderNearbyCitiesLinks()}
                                {status.searching && (
                                    <BusLoader
                                        className={styles.loaderContainer}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                    <div
                        className={classNames(
                            styles.container,
                            { [styles.hidden]: hideResults },
                        )}
                    >
                        <Search
                            date={date}
                            input={input}
                            locale={locale}
                            onDateChange={onDateChange}
                            onInputBlur={onInputBlur}
                            onInputChange={onInputChange}
                            onInputFocus={onInputFocus}
                            onLocationChange={onLocationChange}
                            onPriceChange={onPriceChange}
                            onSearch={onSearch}
                            price={price}
                        />
                    </div>
                </div>
            </div>
        );
    }
}

export { ExplorerHeader };
export default localize(ExplorerHeader, localesConfig.namespace);
